import { AppBar, Box, Button, Modal, Toolbar, Typography, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText, Divider } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import { Box as MUIImage } from "@mui/material";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import Footer from "../components/Footer";

const buttonSx = (location, route, exact = false) => ({
  textTransform: "unset",
  color: exact
    ? location.pathname === route
      ? "primary.main"
      : "text.primary"
    : location.pathname.includes(route)
    ? "primary.main"
    : "text.primary",
  "&:hover": {
    color: "primary.main",
    bgcolor: "transparent",
  },
});

export const NavigatorBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modalContent, setModalContent] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Happy US-Kids Program", path: "/happyus-ppkp" },
    { label: "PP Sessions", path: "/positive-psychology-sessions" },
    { label: "CYJ-Women", path: "/self-discovery" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
  ];

  // Scroll to top on route change (reset "roller" position)
  useEffect(() => {
    // Avoid interfering with hash navigation (anchor links)
    if (location.hash) return;
    // Instant jump; change to behavior: 'smooth' if you prefer animation
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <>
      {/* Full-width AppBar (fixed) */}
      <AppBar position="fixed" sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
        <Toolbar>
          {/* Logo */}
          <MUIImage component="img" src="/assets/cyj-logo.jpeg" alt="Sara's Journal" sx={{ width: 80, height: 70, cursor: 'pointer' }} onClick={() => navigate("/")} />
          <Typography
            variant="h6"
            ml={2}
            fontWeight={600}
            // fontFamily={"Playlist Script, cursive"}
            sx={{flexGrow: 1, cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Sara's Journal
          </Typography>

          {/* spacer to push tabs right on desktop */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} />

          {/* Desktop nav buttons (aligned right) */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, ml: 'auto' }}>
            <Button size="large" disableRipple sx={buttonSx(location, "/", true)} onClick={() => navigate("/")}>Home</Button>
            <Button size="large" disableRipple sx={{ ml: 1, ...buttonSx(location, "/happyus-ppkp") }} onClick={() => navigate("/happyus-ppkp")}>Happy US-Kids Program</Button>
            <Button size="large" disableRipple sx={{ ml: 1, ...buttonSx(location, "/positive-psychology-sessions") }} onClick={() => navigate("/positive-psychology-sessions")}>PP Sessions</Button>
            <Button size="large" disableRipple sx={{ ml: 1, ...buttonSx(location, "/self-discovery") }} onClick={() => navigate("/self-discovery")}>CYJ-Women</Button>
            <Button size="large" disableRipple sx={{ ml: 1, ...buttonSx(location, "/about") }} onClick={() => navigate("/about")}>About</Button>
            <Button size="large" disableRipple sx={{ ml: 1, ...buttonSx(location, "/contact") }} onClick={() => navigate("/contact")}>Contact</Button>
          </Box>

          {/* Mobile burger icon */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, ml: 'auto' }}>
            <IconButton color="inherit" aria-label="open drawer" onClick={() => setMobileOpen(true)}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{ sx: { width: 280, bgcolor: 'background.default' } }}
      >
        <Box sx={{ p: 2 }}>
          <Box display="flex" alignItems="center" mb={1}>
            <MUIImage component="img" src="/assets/cyj-logo.jpeg" alt="Sara's Journal" sx={{ width: 36, height: 36, mr: 1 }} />
            <Typography variant="h6">Sara's Journal</Typography>
          </Box>
          <Divider />
          <List>
            {navItems.map((item) => (
              <ListItem key={item.path} disablePadding>
                <ListItemButton onClick={() => { navigate(item.path); setMobileOpen(false); }}>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      color: location.pathname === item.path || (!item.path.includes('/') && location.pathname.includes(item.path)) ? 'primary' : 'text.primary',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Page background + centered content */}
      <Box
        component="main"
        sx={{
          width: "100%",
          minHeight: "100vh",
          bgcolor: "background.default",
          // push content down to account for fixed AppBar height
          pt: 8, 
          display: "flex",
          justifyContent: "center", // centers the inner container on wide screens
        }}
      >
        {/* Centered container with maxWidth so huge screens don't push content left */}
        <Box
          sx={{
            px: { xs: 2, md: 6 },         // responsive horizontal padding
            py: 4,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            flexGrow: 1,
          }}
        >
          <Modal
            open={modalContent !== null}
            onClose={() => setModalContent(null)}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "transparent",
                borderRadius: 3,
                maxHeight: "90vh",
                overflowY: "auto",
              }}
            >
              {modalContent}
            </Box>
          </Modal>
          {/* Content area */}
          <Box sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            alignItems: "stretch",
            width: "100%",
            
          }}>
            <Outlet context={{ setModalContent }} />
          </Box>
        </Box>
      </Box>

      {/* Footer stays full width below everything */}
      <Box sx={{ width: "100%" }}>
        <Footer />
      </Box>
    </>
  );
};
